import { version } from './version.js';

export const environment = {
    production: true,
    version: version
};
